import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllCodes = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [allCodes, setAllCodes] = useState([]);

  const getAllCodes = ({ branchGuid }) => {
    setLoading(true);
    axiosClient
      .get(`Product/Branch/Codding/GetAllCodes?GUID=${branchGuid}`)
      .then(res => {
        if (res.status === 200) {
          //   enqueueSnackbar(res.data?.message, { variant: 'success' });
          setAllCodes(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getAllCodes, loading, allCodes];
};

export default useGetAllCodes;
